<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="cont"></a><a id="page_v"></a>Contents</h1>
<p class="toc"><a href="#/05_authornotes#note">Author's Note</a></p>
<p class="toc"><a href="#/06_introduction#intro">Introduction</a></p>
<p class="toc1"><a href="#/06_introduction#intro1"><i>Breathe, Pause, Breathe, Pause, Breathe</i> . . .</a></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><a href="#/07_chapter01#c01">1. Step Aside and Experience a Miracle in the Making</a></p>
<p class="toc"><a href="#/08_chapter02#c02">2. Hear the Silence, Rest the Mind, Let God Speak</a></p>
<p class="toc"><a href="#/09_chapter03#c03">3. A Faith-Filled Life</a></p>
<p class="toc"><a href="#/10_chapter04#c04">4. Rapt Attention</a></p>
<p class="toc"><a href="#/11_chapter05#c05">5. Say Something Kind or Nothing at All</a></p>
<p class="toc"><a href="#/12_chapter06#c06">6. The Journey Is Perfect, the Stumbles as Well as the Strides</a></p>
<p class="toc"><a href="#/13_chapter07#c07">7. Fear and Anger</a></p>
<p class="toc"><a href="#/14_chapter08#c08">8. Change Is Good</a></p>
<p class="toc"><a href="#/15_chapter09#c09">9. What's Next?</a></p>
<p class="toc"><a href="#/16_chapter10#c10">10. Forgive Yourself Completely</a></p>
<p class="toc"><a href="#/17_chapter11#c11">11. Remembrances</a></p>
<p class="toc"><a href="#/18_chapter12#c12">12. I Can Choose Peace Instead of This</a></p>
<p class="toc"><a href="#/19_chapter13#c13">13. An Inventory</a></p>
<p class="toc"><a href="#/20_chapter14#c14">14. The Purpose of Life Is to Be Happy</a></p>
<p class="toc"><a href="#/21_chapter15#c15">15. Roses Rather Than Thorns</a></p>
<p class="toc"><a href="#/22_chapter16#c16">16. Teachers of Perspective</a></p>
<p class="toc"><a href="#/23_chapter17#c17">17. Seeking Solitude</a></p>
<p class="toc"><a href="#/24_chapter18#c18">18. Take a Day Off</a></p>
<p class="toc"><a href="#/25_chapter19#c19">19. Now We Can Really Live</a></p>
<p class="toc"><a href="#/26_chapter20#c20">20. Writing Your Story</a></p>
<p class="toc"><a href="#/27_chapter21#c21">21. Impacting Those around You</a></p>
<p class="toc"><a href="#/28_chapter22#c22">22. Improve a Little</a></p>
<p class="toc"><a href="#/29_chapter23#c23">23. Dream List</a></p>
<p class="toc"><a href="#/30_chapter24#c24">24. Doing More Than Nothing</a></p>
<p class="toc"><a href="#/31_chapter25#c25">25. Pay Attention to the Moment</a></p>
<p class="toc"><a id="page_vi"></a><a href="#/32_chapter26#c26">26. What to Do Today</a></p>
<p class="toc"><a href="#/33_chapter27#c27">27. Making Small Efforts to Improve the World</a></p>
<p class="toc"><a href="#/34_chapter28#c28">28. Fulfilling Your Potential</a></p>
<p class="toc"><a href="#/35_chapter29#c29">29. Who Will You Bring to the Party?</a></p>
<p class="toc"><a href="#/36_chapter30#c30">30. Make Yourself Smile</a></p>
<p class="toc"><a href="#/37_chapter31#c31">31. Changing Ourselves to Change the World</a></p>
<p class="toc"><a href="#/38_chapter32#c32">32. Reaching Out</a></p>
<p class="toc"><a href="#/39_chapter33#c33">33. Influences</a></p>
<p class="toc"><a href="#/40_chapter34#c34">34. We Become What We Think</a></p>
<p class="toc"><a href="#/41_chapter35#c35">35. Listening for Messages</a></p>
<p class="toc"><a href="#/42_chapter36#c36">36. Being in Charge of Who We Are</a></p>
<p class="toc"><a href="#/43_chapter37#c37">37. Remembering Those Who Made a Mark on Our Lives</a></p>
<p class="toc"><a href="#/44_chapter38#c38">38. The Greatest Gifts We Can Offer One Another</a></p>
<p class="toc"><a href="#/45_chapter39#c39">39. It's Time for a Change of Pace</a></p>
<p class="toc"><a href="#/46_chapter40#c40">40. Stepping Aside</a></p>
<p class="toc"><a href="#/47_chapter41#c41">41. Be Kind</a></p>
<p class="toc"><a href="#/48_chapter42#c42">42. Remembering the Little Things</a></p>
<p class="toc"><a href="#/49_chapter43#c43">43. Having Goals</a></p>
<p class="toc"><a href="#/50_chapter44#c44">44. Letting Go of the Past</a></p>
<p class="toc"><a href="#/51_chapter45#c45">45. Feeling the Wow</a></p>
<p class="toc"><a href="#/52_chapter46#c46">46. Your Mission Statement</a></p>
<p class="toc"><a href="#/53_chapter47#c47">47. Shape Your Mind</a></p>
<p class="toc"><a href="#/54_chapter48#c48">48. Overcoming Fear</a></p>
<p class="toc"><a href="#/55_chapter49#c49">49. A Vital Person</a></p>
<p class="toc"><a href="#/56_chapter50#c50">50. Cultivating Warm Relations</a></p>
<p class="toc"><a href="#/57_chapter51#c51">51. What Are You Grateful for Today?</a></p>
<p class="toc"><a href="#/58_chapter52#c52">52. Do You Like Yourself Enough?</a></p>
<p class="toc"><a href="#/59_chapter53#c53">53. Your Mind Holds the Power</a></p>
<p class="toc"><a href="#/60_chapter54#c54">54. Random Acts of Fun</a></p>
<p class="toc"><a href="#/61_chapter55#c55">55. Expressing Thanks</a></p>
<p class="toc"><a href="#/62_chapter56#c56">56. What's the Biggest Lesson of Your Life So Far?</a></p>
<p class="toc"><a href="#/63_chapter57#c57">57. Be a Mentor</a></p>
<p class="toc"><a id="page_vii"></a><a href="#/64_chapter58#c58">58. Lead by Example</a></p>
<p class="toc"><a href="#/65_chapter59#c59">59. What Makes You Come Alive?</a></p>
<p class="toc"><a href="#/66_chapter60#c60">60. Age Aside</a></p>
<p class="toc"><a href="#/67_chapter61#c61">61. Say What You Need to Say</a></p>
<p class="toc"><a href="#/68_chapter62#c62">62. Your Timeline</a></p>
<p class="toc"><a href="#/69_chapter63#c63">63. Life's “Accidents”</a></p>
<p class="toc"><a href="#/70_chapter64#c64">64. Living in the Moment with Rapt Attention</a></p>
<p class="toc"><a href="#/71_chapter65#c65">65. You Can't Change Others, So Change Yourself</a></p>
<p class="toc"><a href="#/72_chapter66#c66">66. Is Real Peace Ever an Actuality?</a></p>
<p class="toc"><a href="#/73_chapter67#c67">67. Telling Your Secrets</a></p>
<p class="toc"><a href="#/74_chapter68#c68">68. Living with Death</a></p>
<p class="toc"><a href="#/75_chapter69#c69">69. The First Day of Your Retired Life</a></p>
<p class="toc"><a href="#/76_chapter70#c70">70. The Serenity Prayer</a></p>
<p class="toc"><a href="#/77_chapter71#c71">71. Your Life Philosophy</a></p>
<p class="toc"><a href="#/78_chapter72#c72">72. Recalling Your Life Lessons</a></p>
<p class="toc"><a href="#/79_chapter73#c73">73. A New Challenge</a></p>
<p class="toc"><a href="#/80_chapter74#c74">74. What if You Had Six Months to Live?</a></p>
<p class="toc"><a href="#/81_chapter75#c75">75. Enthusiasm</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?b8f84242